// extracted by mini-css-extract-plugin
export default {"root":"hamburgerButton-module--root--KPv1Z","svg":"hamburgerButton-module--svg--LaRtY"};